export class CoreErrorCodes {
  public static Unknown = 'Unknown';
  public static CustomLog = 'CustomLog';
  public static InvalidState = 'InvalidState';
  public static Offline = 'Offline';
  public static LocationPermissionDenied = 'LocationPermissionDenied';
  public static GeolocationPositionError = 'GeolocationPositionError';
}
